<template>
  <div class="row">
    <div class="col-md-3 fme-small-cards" v-for="(item, index) in items" :key="index">
      <BaseLargeCard :cardTitle="$t(`${item.title}.name`)" :cardType="item.type" :cardUrl="item.route" :cardInfoType="item.infoType" :cardPercent="item.percent" :cardQuantityNumber="item.quantityNumber" :cardQuantityString="item.quantityString" :cardQuantityText="item.quantityText" :cardTopItems="item.topItems" :cardHasTopItems="item.hasItems" />
    </div>
  </div>
</template>

<script>
const BaseLargeCard = () => import('@/components/fragment/card/BaseLargeCard')

export default {
  name: 'CrudLargeCardNavigation',
  mounted () {
    const element = document.getElementsByClassName('fme-metric-cards')[0]
    const y = element.getBoundingClientRect().top
    window.scrollTo({top: y, behavior: 'smooth'})
  },
  data () {
    return {
    }
  },
  props: {
    items: Array
  },
  components: {
    BaseLargeCard
  },
  computed: {
  }
}
</script>

<style lang="scss">
.fme-small-cards {
  padding-top: 15px;
  padding-bottom: 15px;
  & + div {
    padding-right: 8px;
  }
}
</style>
